// 是否企业微信
export const isQywx = () => {
  return window.navigator.userAgent.toLowerCase().includes('wxwork')
}
